webpackJsonp([333],{

/***/ 1270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TekeCustomerDetail_vue__ = __webpack_require__(3019);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702ca5b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TekeCustomerDetail_vue__ = __webpack_require__(5565);
function injectStyle (ssrContext) {
  __webpack_require__(5563)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-702ca5b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TekeCustomerDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702ca5b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TekeCustomerDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      detailData: {
        id: this.$route.params.id,
        number: null,
        name: null,
        company: null,
        managementfees: null,
        balance: null,
        freezing: null,
        totalspentmoney: null,
        ongoingtaskmoney: null,
        totalhirenum: null,
        ongoingtasknum: null,
        totalmanagementfee: null,
        totaltasknum: null
      },

      table: [{
        key: 'id',
        label: '客户ID'
      }, {
        key: 'number',
        label: '客户唯一编号'
      }, {
        key: 'name',
        label: '客户名'
      }, {
        key: 'company',
        label: '客户公司'
      }, {
        key: 'managementfees',
        label: '客户管理费率'
      }, {
        key: 'balance',
        label: '客户当前余额'
      }, {
        key: 'freezing',
        label: '客户当前冻结金额'
      }, {
        key: 'totalspentmoney',
        label: '客户总消费金额'
      }, {
        key: 'totaltasknum',
        label: '客户总投放工单数'
      }, {
        key: 'totalhirenum',
        label: '客户总雇佣人数'
      }, {
        key: 'ongoingtasknum',
        label: '客户当前进行中的工单数'
      }, {
        key: 'operation',
        label: '操作'
      }]

    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.setFormData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getTekeCustomerDetail']), {
    ifKey: function ifKey(scope, name) {
      return scope.row.key === name;
    },
    setFormData: function setFormData() {
      var _this = this;

      return request.page('getTekeCustomerDetail', this.detailData.id).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.detailData, data);
      });
    },
    getValue: function getValue(scope, name) {
      return this.detailData[scope.row.key][name];
    },
    getFixedValue: function getFixedValue(value) {
      var number = parseFloat(value);
      return number.toFixed(2);
    }
  })
});

/***/ }),

/***/ 5563:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("bcd25e76", content, true, {});

/***/ }),

/***/ 5564:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TekeCustomerDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-row',{staticClass:"sj-container"},[_c('el-table',{attrs:{"highlight-current-row":true,"data":_vm.table,"show-header":false,"border":""}},[_c('el-table-column',{attrs:{"width":"150","prop":"label"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.ifKey(scope, 'managementfees') && !_vm.ifKey(scope, 'totalspentmoney') && !_vm.ifKey(scope, 'ongoingtasknum') && !_vm.ifKey(scope, 'operation') && !_vm.ifKey(scope, 'balance'))?_c('span',[_vm._v("\n            "+_vm._s(_vm.detailData[scope.row.key])+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'managementfees'))?_c('span',[_vm._v("\n            "+_vm._s(parseInt(_vm.detailData[scope.row.key]*100))+"%\n          ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'totalspentmoney'))?_c('span',[_vm._v("\n            "+_vm._s(_vm.getFixedValue(_vm.detailData[scope.row.key]))+" (管理费: "+_vm._s(_vm.getFixedValue(_vm.detailData['totalmanagementfee']))+")\n          ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'ongoingtasknum'))?_c('span',[_vm._v("\n            "+_vm._s(_vm.detailData[scope.row.key])+" (奖金总额: "+_vm._s(_vm.getFixedValue(_vm.detailData['ongoingtaskmoney']))+")\n          ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'balance'))?_c('span',[_vm._v("\n            "+_vm._s(_vm.getFixedValue(_vm.detailData[scope.row.key]))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'operation'))?_c('span',[_vm._v("\n            客户订单列表 |\n            "),_c('router-link',{attrs:{"to":{ path: '/teke_customer/balance/table/'+_vm.detailData['id']+'?customername='+_vm.detailData['name']}}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("客户消费流水")])],1),_vm._v("|\n            "),_c('router-link',{attrs:{"to":{ path: '/teke_customer/recharge/table/'+_vm.detailData['id']+'?customername='+_vm.detailData['name']}}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("客户充值记录")])],1)],1):_vm._e()]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/333.07322bf4ef161ab6d763.js